<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_2">Dedication</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_4">This is dedicated to all those who have continued to support and encourage me. I love and cherish you all.</p>
<p class="block_3" id="calibre_pb_1"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?6016888a